export default "__VITE_ASSET__9807b75d__"